export default __webpack_public_path__ + "static/media/logoTilt.43b36a11.jpg";